import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import Login from "./Login";
import SetPassword from "./SetPassword";
import App from "./solar_platform_CI";

// Detects an invite/recovery callback in the URL hash. Supabase appends
// #access_token=...&type=invite (or type=recovery) — when we see that,
// the user needs to set a password before reaching the app.
function isPasswordSetCallback() {
  const h = window.location.hash || "";
  return /access_token=/.test(h) && /type=(invite|recovery|signup)/.test(h);
}

export default function AppGate() {
  const [session, setSession] = useState(null);
  const [ready, setReady] = useState(false);
  const [needsPassword, setNeedsPassword] = useState(isPasswordSetCallback());

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setReady(true);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((event, s) => {
      setSession(s);
      // Supabase fires PASSWORD_RECOVERY when a recovery link is processed.
      if (event === "PASSWORD_RECOVERY") setNeedsPassword(true);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  if (!ready) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Inter', system-ui, sans-serif",
        color: "#1F3A5F",
        fontSize: 13,
      }}>Loading…</div>
    );
  }

  if (needsPassword && session) {
    return <SetPassword onDone={() => {
      setNeedsPassword(false);
      // Clean up the hash so a refresh doesn't trigger this again.
      window.history.replaceState(null, "", window.location.pathname);
    }} />;
  }

  if (!session) return <Login />;

  return (
    <>
      <App />
      <LogoutButton email={session.user?.email} />
    </>
  );
}

function LogoutButton({ email }) {
  async function handleLogout() {
    await supabase.auth.signOut();
  }
  return (
    <div style={{
      position: "fixed",
      top: 12,
      right: 16,
      zIndex: 10000,
      display: "flex",
      alignItems: "center",
      gap: 10,
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: 11,
    }}>
      <span style={{ color: "#BFD3F0" }}>{email}</span>
      <button
        onClick={handleLogout}
        style={{
          background: "transparent",
          color: "#fff",
          border: "1px solid #BFD3F0",
          padding: "4px 10px",
          borderRadius: 4,
          fontSize: 11,
          fontFamily: "'Inter', system-ui, sans-serif",
          cursor: "pointer",
        }}
      >
        Sign out
      </button>
    </div>
  );
}
